/**
 * API 工具模組
 *
 * 開發環境：Vite proxy 會把 /api 轉發到 localhost:3000
 * 生產環境：需要用完整的 VITE_API_URL 前綴打到 Railway 後端
 */

const API_BASE = (import.meta as unknown as { env: { VITE_API_URL?: string; DEV?: boolean } }).env.VITE_API_URL || '';

/**
 * 把相對 API 路徑轉成完整 URL
 *
 * 開發時: '/api/auth/me' → '/api/auth/me' (Vite proxy 處理)
 * 生產時: '/api/auth/me' → 'https://felicity2.tonetown.ai/api/auth/me'
 */
export function apiUrl(path: string): string {
  if (API_BASE) {
    // 生產環境：加上後端 URL 前綴
    const base = API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${base}${cleanPath}`;
  }
  // 開發環境：走 Vite proxy
  return path;
}

/**
 * 封裝 fetch，自動加上 API_BASE 和 credentials
 */
export async function apiFetch(path: string, options?: RequestInit): Promise<Response> {
  const url = apiUrl(path);
  return fetch(url, {
    ...options,
    credentials: 'include',  // 確保跨域時也帶上 cookie (JWT)
  });
}
